<template>
	<div class="inputNumBox">
		<el-input-number v-model="value" v-bind="$attrs" @change="change"></el-input-number>
	</div>
</template>

<script>
export default {
	name: 'inputNumBox',
	props: {
		tableData: Object,
		scope: Object,
	},
	data() {
		let that = this;
		return {
			value: that.scope.row[that.tableData.bind],
		};
	},
	computed: {
		size() {
			return this.tableData.size || 'mini';
		},
	},
	watch: {
		'scope.row': {
			handler() {
				this.value = this.scope.row[this.tableData.bind];
			},
			deep: true,
			immediate: true,
		},
	},

	methods: {
		change(val) {
			let { scope, tableData } = this;
			this.$set(this.scope.row, this.tableData.bind, this.value);
			tableData.change && tableData.change(val, scope, tableData);
		},
	},
};
</script>

<style lang="scss" scoped>
.inputNumBox {
	display: flex;
	.bianji-icon {
		margin-left: 10px;
		cursor: pointer;
	}
}
</style>
